import { useEffect, useState } from "react";
import { UniqueIdentifier } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";

import { AccordionItem, AccordionItemUpdate, PageModule } from "../../../../../../types/working-model";
import Item from "./accordion-item/item";

interface SortableItemProps {
	containerId: UniqueIdentifier;
	id: UniqueIdentifier;
	index: number;
	handle: boolean;
	disabled?: boolean;
	getIndex(id: UniqueIdentifier): number;
	value: AccordionItem;
	onRemove?(removedItemId: UniqueIdentifier): void;
	hideRemoveButton?: boolean;
	onContentBlur?(props: AccordionItemUpdate): void;
	module?: PageModule;
}

const SortableItem: React.FC<SortableItemProps> = ({
	disabled,
	id,
	index,
	handle,
	containerId,
	value,
	hideRemoveButton,
	onContentBlur,
	onRemove,
	module,
}) => {
	const {
		setNodeRef,
		listeners,
		isDragging,
		isSorting,
		transform,
		transition
	} = useSortable({
		id
	});
	const mounted = useMountStatus();
	const mountedWhileDragging = isDragging && !mounted;

	return (
		<Item
			ref={disabled ? undefined : setNodeRef}
			value={value}
			dragging={isDragging}
			sorting={isSorting}
			handle={handle}
			index={index}
			transition={transition}
			transform={transform}
			fadeIn={mountedWhileDragging}
			listeners={listeners}
			containerId={containerId}
			onRemove={onRemove}
			hideRemoveButton={hideRemoveButton}
			onContentBlur={onContentBlur}
			module={module}
		/>
	);
};

export default SortableItem;

function useMountStatus() {
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => setIsMounted(true), 500);

		return () => clearTimeout(timeout);
	}, []);

	return isMounted;
}
